import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { loginApi } from "../helper/api_helper.js";
import web_logo from "../../src/assets/MAIN_LOGO_3.png";
import banner_img from "../assets/banner.webp";

const SignInLayer = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSignInClick = async () => {
    if (!email) {
      toast.error("Please enter Email");
      return;
    }

    if (!password) {
      toast.error("Please enter Password");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        email,
        password,
      };

      console.log(payload);

      const res = await loginApi(payload);
      console.log(res.data);

      if (res.status) {
        const { accessToken, adminData } = res.data;

        localStorage.setItem("token", accessToken);
        localStorage.setItem("adminData", JSON.stringify(adminData));
        localStorage.setItem("role", adminData.role);
        localStorage.setItem("isLoggedIn", "true");

        toast.success("Login successful");

        navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error?.message || "Login failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      {/* Left Side Image */}
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img
            src={banner_img}
            alt="banner"
            style={{ height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>

      {/* Right Side Login Form */}
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src={web_logo} alt="logo" />
            </Link>

            <h4 className="mb-12">Sign In to your Account</h4>

            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>

          <form onSubmit={(e) => e.preventDefault()}>
            {/* Email Input */}
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:user" />
              </span>

              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password Input */}
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {/* Toggle Password */}
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
              >
                <i
                  className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}
                ></i>
              </span>
            </div>

            {/* Sign In Button */}
            <button
              type="button"
              onClick={handleSignInClick}
              disabled={loading}
              className={`btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-12 ${loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
